@use './shared-axis-styles' as *;

@layer design-system {
  .chartAxisG {
    @include shared-axis-styles;

    &.showLine {
      :global(.domain) {
        display: none;
      }

      :global(.tick) > line {
        display: none;
      }
    }
  }

  .axisLine {
    stroke: var(--border-soft);
  }

  .axisBorderLine {
    stroke: var(--border-soft);
  }
}
